import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { ProjectException } from '../models/ProjectException';

export class ProjectExceptionMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any, projectId: number): ProjectException {
    const id = this.gqlIdEncoder.decode(data.id);

    return new ProjectException(id, projectId, data.type, data.term ?? '', data.description, data.active, data.traceType);
  }
}
